<template>
  <div class="programme">

    <div class="swiper-container programmeswiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
          <div class="difficult_box">
            <div class="difficult">
              <div class="title_box">我们解决的难题</div>
              <div class="li"
                   style="margin-top:0.242rem">
                <div class="title">洞悉您的受众</div>
                <p>
                  这是一个价值消费的时代，消费者聪明而苛刻，总是孜孜不倦的提出更高的要求与期望，捉摸不透又难以满足。他们逐渐从七十年代以来的发展热潮中冷静下来，他们了解市场机制，明晰欺诈与真实，理性的看待产品的实际价值，难以伺候。您需要不再仅仅是优秀的外观，还要向他们传达您的诚意与承诺，平衡您与终端用户的诉求。
                </p>
              </div>
              <div class="li">
                <div class="title">精准定位市场</div>
                <p>
                  在互联网上您的产品想要给谁看？如何让更多的人看到？如何呈现？如何比竞争对手更具优势？千人过江还是另辟新径？这些可能是您的难题，也可能是您的生财之道。无论如何，深入挖掘潜在客户，精准定位属于您的市场，零一零二信息技术与您同在。
                </p>
              </div>
              <div class="li">
                <div class="title">跳出行业思考</div>
                <p>
                  您一定比我们更了解您的企业，也更早的开始关注您的竞争对手，但正是这种深入的理解往往使您陷入尴尬的思维定式之中，难以发现市场竞争中新鲜美味的故事，一次次错失通过创新摆脱竞争对手尾行的机会。零一零二信息技术与您协同，从不同的角度观察、思考，感知风险，寻找机会，通过最佳的实践方案，精准把握市场、产品与价值的黄金点，保持您竞争的优势。
                </p>
              </div>
              <div class="li">
                <div class="title">公司技术实力</div>
                <p>
                  为用户提供线上线下一体化的移动整合营销解决方案，专业技术研发团队拥有多个自主研发平台类产品，服务用户200+、行业20+，对产品有着独特的分析和警觉的市场掌控；以大数据、智能算法、营销自动化等技术及优质媒体源，为企业提供一站式移动产品搭建、互动引流、留存成交等一站式服务方案。
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 第三屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">

            <el-scrollbar ref="programmescroll"
                          style="height: 100%">
              <div class="other_box">
                <div class="title_box">行业解决方案</div>
                <div class="title_info">零一零二信息技术主要是以互联网和手机为载体，通过开发一系列互联网产品为顾客提供社交行业、电商行业、金融行业、
                  餐饮行业、教育行业、医疗行业等APP开发解决方案等，是国内知名的行业APP开发公司。</div>
                <div class="other">
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan1.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">社区公众号开发</div>
                      <p>
                        由于我国城市化进程不断加快，线下线下的社区建设...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan4.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">房地产小程序开发</div>
                      <p>
                        为了迎合市场的发展趋势，很多行业都有了相应的...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan3.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">新闻APP开发</div>
                      <p>
                        社会的发展更替使得人们生活也发生了一定的变化，移动互联网...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan2.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">教育APP开发</div>
                      <p>
                        所谓教育APP就是利用移动互联网进行线上学习的...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan3.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">餐饮小程序开发</div>
                      <p>
                        餐饮小程序是一款专为用户提供手机点餐及餐厅介绍...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan6.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">电商APP开发</div>
                      <p>
                        随着现在智能手机的广泛普及，很多日常消费都是通过手机一...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan5.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">企业官网web开发</div>
                      <p>
                        随着移动互联网的发展，企业公司都有一个专属标志性的...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                  <div class="other_li">
                    <div class="img_box">
                      <img src="../../static/images/img/jiejuefangan/fangan1.png"
                           alt="">
                    </div>
                    <div class="text_box">
                      <div class="title">社交APP开发</div>
                      <p>
                        随着移动互联网的不断发展，使用啥叫软件已经成为当代...
                      </p>
                    </div>
                    <div class="cover"></div>
                    <div class="button">查看详情</div>
                  </div>
                </div>
              </div>
              <Footer></Footer>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Footer from "@/components/footer.vue";
import Banner from "@/components/banner.vue";
export default {
  computed: {
    programmePage: {
      get () {
        return this.$store.state.programmePage
      },
      set (value) {
        this.$store.commit('putprogrammePage', value)
      }
    }
  },
  components: {
    Footer,
    Banner
  },
  data () {
    return {
      programmeswiper: '',
      programmeswiperId: 0,
      scrollTop: 0,
    }
  },
  watch: {
    programmeswiperId: {
      handler (e) {
        this.programmePage = e
        if (e == 2) {
          this.$refs.programmescroll.wrap.scrollTop = 1
          this.programmeswiper.disableMousewheelControl()
        }
      }
    },
    programmePage: {
      handler (e) {
        if (e !== this.programmeswiperId) {
          this.programmeswiper.slideTo(e)
        }
      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.programmescroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.programmeswiper.slidePrev()
        _this.programmeswiper.enableMousewheelControl()
      }
    }

    this.programmeswiper = new Swiper('.programmeswiper', {
      initialSlide: _this.programmePage,
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 700, // 每次切换时长
      // scrollbar: '.swiper-scrollbar', // 滚动条
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.programmeswiperId = swiper.activeIndex
      }
    })
  },
  methods: {
    ...mapMutations(['putprogrammePage']),
  }
}
</script>

<style lang="scss" scoped>
@keyframes otherButton {
  0% {
    visibility: visible;
    z-index: 2;
  }
  100% {
    visibility: visible;
    left: 50%;
    z-index: 2;
  }
}
.programme {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #fff;
    opacity: 1;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .title_info {
    font-size: 0.1146rem;
    font-family: MicrosoftYaHei;
    line-height: 0.2083rem;
    color: #999999;
    opacity: 1;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .difficult_box {
    width: 100vw;
    height: 100vh;
    background-image: url("../../static/images/img/nanti.png");
    background-size: 100% 100%;
    color: #fff;
    overflow: hidden;
    .difficult {
      margin: 0.5504rem 1.875rem 0;
      .li {
        text-align: left;
        margin-top: 0.1083rem;
        .title {
          display: inline-block;
          font-size: 0.1042rem;
          font-family: MicrosoftYaHei-Bold;
          line-height: 0.1823rem;
          color: #ffffff;
          letter-spacing: 0.0052rem;
          opacity: 1;
          background: #f29912;
          opacity: 1;
          border-radius: 10px;
          padding: 0.026rem 0.0921rem;
          font-weight: 700;
        }
        p {
          font-size: 0.0938rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1667rem;
          color: #ffffff;
          letter-spacing: 0.0052rem;
          opacity: 1;
          margin: 0.0381rem 0 0.1563rem;
        }
      }
    }
  }
  .other_box {
    width: 100vw;
    padding-top: 0.625rem;

    .title_box {
      color: #000;
    }
    .title_info {
      width: 60%;
      margin: 0 auto;
      font-size: 0.1146rem;
      font-family: MicrosoftYaHei;
      line-height: 0.2083rem;
      color: #666666;
      opacity: 1;
    }
    .other {
      position: relative;
      width: 6.25rem;
      margin: 0.1042rem auto 0rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .other_li {
        position: relative;
        width: 1.4375rem;
        height: 1.4688rem;
        border: 1px solid #cbcbcb;
        border-radius: 0.0521rem;
        margin-bottom: 0.152rem;
        cursor: pointer;
        overflow: hidden;
        transition: 0.3s;
        .img_box {
          width: 100%;
          height: 0.8333rem;
          transition: 0.3s;
          transform-origin: 50% 50%;
          img {
            width: 100%;
            height: 0.8333rem;
            transition: 0.3s;
          }
        }
        .text_box {
          padding: 0.0521rem 0.1042rem;
          // background-color: #fff;
          transition: 0.3s;
          .title {
            font-size: 0.1042rem;
            font-family: MicrosoftYaHei;
            line-height: 0.1875rem;
            color: #000000;
            opacity: 1;
            transition: 0.3s;
          }
          p {
            display: -webkit-box;
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*隐藏后添加省略号*/
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; //想显示多少行
            font-size: 0.0729rem;
            font-family: MicrosoftYaHei;
            line-height: 0.1406rem;
            color: #999999;
            opacity: 1;
            transition: 0.3s;
          }
        }
        .cover {
          position: absolute;
          top: 0rem;
          left: 0rem;
          width: 100%;
          height: 100%;
          background-color: #00000050;
          opacity: 0;
          transition: 0.3s;
          z-index: 1;
        }
        .button {
          visibility: hidden;
          position: absolute;
          top: 65%;
          left: -50%;
          transform: translate(-50%, -50%);
          width: 0.8333rem;
          height: 0.2604rem;
          background-color: #fff;
          opacity: 1;
          border-radius: 0.0208rem;
          font-size: 0.1042rem;
          font-family: MicrosoftYaHei;
          line-height: 0.2604rem;
          color: #666666;
          opacity: 1;
          transition: 0.3s;
        }
        .button:hover {
          background-color: #ff6100;
          color: #ffffff;
        }
      }
      .other_li:hover {
        .cover {
          opacity: 1;
        }
        .img_box {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 0.8333rem;
            transform: scale(2.6);
          }
        }
        .text_box {
          width: 80%;
          position: absolute;
          left: 50%;
          top: 30%;
          transform: translate(-50%, -50%);
          z-index: 2;
          .title {
            color: #fff;
          }
          p {
            color: #fff;
          }
        }
        .button {
          animation: otherButton 0.2s 0.3s forwards;
        }
      }
      .other_li:nth-child(4) {
        margin-right: 0rem;
      }
      .other_li:nth-child(8) {
        margin-right: 0rem;
      }
    }
  }
}
</style>